import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const Save: FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" {...props}>
    <path
      fillRule="evenodd"
      d="M4 2c-1.1046 0-2 .8954-2 2v16c0 1.1046.8954 2 2 2h16.5c1.1046 0 2-.8954 2-2V7.4142A1.9999 1.9999 0 0 0 21.9142 6L18.5 2.5858A2 2 0 0 0 17.0858 2H4Zm13 18h3.5V7.4142L17.0858 4H17v2.5c0 1.1046-.8954 2-2 2H7c-1.1046 0-2-.8954-2-2V4H4v16h1v-5c0-1.1046.8954-2 2-2h8c1.1046 0 2 .8954 2 2v5ZM7 20h8v-5H7v5Zm7.5-16h.5v2.5H7V4h5.5v1.5h2V4Z"
      clipRule="evenodd"
    />
  </SvgIcon>
)
